// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3kHjl","left":"InfoRow_left__3Vp9h"};